// components/AfghanDatePickerModern.jsx
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/colors/green.css";
const moment = require("moment-jalaali");

// Custom Afghan month names (overriding the default Persian locale)
const afghanLocale = {
  ...persian_fa,
  months: [
    ["حمل", "حمل"],
    ["ثور", "ثور"],
    ["جوزا", "جوزا"],
    ["سرطان", "سرطان"],
    ["اسد", "اسد"],
    ["سنبله", "سنبله"],
    ["میزان", "میزان"],
    ["عقرب", "عقرب"],
    ["قوس", "قوس"],
    ["جدی", "جدی"],
    ["دلو", "دلو"],
    ["حوت", "حوت"],
  ],
};

function AfghanDatePickerModern({
  value,
  onChange,
  required = true,
  clearable = true,
  disabled = false,
}) {
  const pickerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Force clear the input when value is falsy
    if (!value && pickerRef.current) {
      const input = pickerRef.current.querySelector("input");
      if (input) {
        input.value = "";
      }
    }
  }, [value]);

  const handleDateChange = (date) => {
    if (date) {
      console.log("Selected date object:", date);
      let dateG = date.year + "-" + (date.monthIndex + 1) + "-" + date.day;
      let m = moment(dateG, "jYYYY-jM-jD").format("YYYY-M-D");

      console.log("Gregorian:", m);

      onChange(m);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation(); // Prevent opening the date picker
    onChange(""); // Clear the value

    // Clear the input field
    if (pickerRef.current) {
      const input = pickerRef.current.querySelector("input");
      if (input) {
        input.value = "";
      }
    }
  };

  return (
    <div
      ref={pickerRef}
      style={{
        width: "100%",
        position: "relative",
        direction: "ltr", // Keep buttons on the right
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <DatePicker
        value={value ? moment(value, "YYYY-M-D").format("jYYYY-jM/jD") : null}
        onChange={handleDateChange}
        calendar={persian}
        locale={afghanLocale}
        calendarPosition="bottom-right"
        format="YYYY-MM-DD"
        digits={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
        placeholder="تاریخ را انتخاب کنید"
        className="green"
        containerStyle={{ width: "100%" }}
        inputClass="custom-input"
        required={required}
        disabled={disabled}
        style={{
          width: "100%",
          height: "34px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          padding: "0 30px 0 10px", // Add right padding for clear button
          fontSize: "14px",
        }}
      />

      {/* Clear button - only show when there's a value and clearable is true */}
      {clearable && value && (
        <button
          onClick={handleClear}
          style={{
            position: "absolute",
            right: "8px",
            top: "50%",
            transform: "translateY(-50%)",
            background: isHovered ? "#f0f0f0" : "transparent",
            border: "none",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: "16px",
            color: "#666",
            transition: "all 0.2s",
            padding: 0,
            lineHeight: 1,
          }}
          title="Clear date"
          type="button"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default AfghanDatePickerModern;
